import React from 'react';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';

const useAlert = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { message, variant, key, onUpdate } = useSelector(({ coreui }) => coreui.alert);

  React.useEffect(() => {
    if (onUpdate) {
      enqueueSnackbar(message, { variant, key });
    }
  }, [enqueueSnackbar, message, variant, key, onUpdate]);
};

export default useAlert;
